import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import { get as lodashGet } from 'lodash';
import { connect } from '../../../redux/connect';
import { Button, Loader, Checkbox, SimpleModal } from '@adsk/bim360-matrix-react-components';
import { actions as formActions } from 'react-redux-form';
import {
  changeLocationAction,
  createIssueAction,
} from '../../../redux/actions';
import {
  getCurrentUser,
  getOxygenMappings,
  getAllIssues,
  getPendingIssue,
  getPendingIssueForm,
  getAppLoading,
} from '../../../redux/selectors';
import { oxygenType, userType, pendingIssueAttributesType, pendingIssueFormAttributesType } from '../../../constants/proptype-validation';
import { screenType } from '../../../constants/analytics';
import IssueCreateForm from '../../../components/issueCreateForm';

class IssueNewModal extends PureComponent {

  constructor() {
    super(...arguments);
    this.state = {
      createAnother: false,
      isSubmitting: false,
      error: null,
    };
    this._issueCreateFormContainer = null;
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleSaveStart = this._handleSaveStart.bind(this);
    this.handleSaveSuccess = this._handleSaveSuccess.bind(this);
    this.handleSaveError = this._handleSaveError.bind(this);
    this._toggleCreateAnother = this._toggleCreateAnother.bind(this);
  }

  componentWillUnmount() {
    this.props.resetFormAction('pendingIssue');
    this.props.resetValidityFormAction('pendingIssue');
  }

  _handleSubmit() {
    this._issueCreateFormContainer && this._issueCreateFormContainer.saveIssue();
  }

  _handleSaveStart() {
    this.setState({
      isSubmitting: true,
      error: null,
    });
  }

  _handleSaveSuccess() {
    this.setState({
      isSubmitting: false,
    });
    //store.dispatch(fetchIssuesAction());  // reload issues with the new created
    if (!this.state.createAnother) {
      this.props.onClose();
    }
  }

  _handleSaveError(error) {
    this.setState({
      isSubmitting: false,
      error: error || true,
    });
  }

  _renderBody() {
    const { container, loading } = this.props;
    const { isSubmitting, error } = this.state;
    if (loading || !lodashGet(this.props.currentUser, 'attributes.rfis.new')) {
      return <Loader />;
    }
    return (
      <div className="isui-form">
        <IssueCreateForm
          ref={(c) => { this._issueCreateFormContainer = c; }}
          origin={screenType.PROJECT}
          onSaveStart={this.handleSaveStart}
          onSaveSuccess={this.handleSaveSuccess}
          onSaveError={this.handleSaveError}
          disabled={isSubmitting}
          error={error}
          container={container}
          createAnother={this.state.createAnother}
          focusForm
        />
      </div>
    );
  }

  _toggleCreateAnother() {
    this.setState({ createAnother: !this.state.createAnother });
  }

  renderFooter() {
    const { pendingIssueForm, onClose } = this.props;
    const { isSubmitting } = this.state;

    const saveButtonClasses = cx('IssueNew__create-button', {
      ['IssueNew__create-button--saving']: isSubmitting,
    });
    const saveButtonText = isSubmitting ? T.translate('new.creating') : T.translate('new.create');
    return (
      <div className="IssueNew__button-footer">
        <div className="IssueNew__button-footer-create-another" data-testid="IssueNew__createAnother">
          <Checkbox onChange={this._toggleCreateAnother} checked={this.state.createAnother} label={T.translate('new.createAnother')} />
        </div>
        <Button
          styleType={Button.StyleType.LINK_SECONDARY}
          onClick={onClose}
          data-testid="IssueNew__cancelButton"
        >
          {T.translate('navigation.cancel')}
        </Button>
        <Button
          styleType={Button.StyleType.PRIMARY}
          className={saveButtonClasses}
          data-testid="IssueNew__createButton"
          onClick={this.handleSubmit}
          disabled={pendingIssueForm.pristine || isSubmitting}
        >
          {saveButtonText}
        </Button>
      </div>
    );
  }

  render() {
    const { container, onClose } = this.props;
    const { isSubmitting } = this.state;

    return (
      <SimpleModal
        title={T.translate('projectGrid.newModal.title')}
        className="IssueNewModal"
        container={container}
        onExited={onClose}
        disableModalExit={isSubmitting}
        footer={this.renderFooter()}
        backdrop="static"
        modalProps={
          { 'data-testid': 'IssueNewModal' }
        }
      >
        {this._renderBody()}
      </SimpleModal>
    );
  }
}

IssueNewModal.displayName = 'IssueNewModal';

IssueNewModal.propTypes = {
  container: PropTypes.object,
  createIssueAction: PropTypes.func.isRequired,
  changeFormValueAction: PropTypes.func.isRequired,
  setErrorsFormAction: PropTypes.func.isRequired,
  resetFormAction: PropTypes.func.isRequired,
  resetValidityFormAction: PropTypes.func.isRequired,
  oxygen: oxygenType.isRequired,
  pendingIssue: pendingIssueAttributesType,
  pendingIssueForm: pendingIssueFormAttributesType,
  currentUser: userType,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    allIssues: getAllIssues(state),
    pendingIssue: getPendingIssue(state),
    pendingIssueForm: getPendingIssueForm(state),
    oxygen: getOxygenMappings(state),
    currentUser: getCurrentUser(state),
    loading: getAppLoading(state),
  };
};

const { change: changeFormValueAction, reset: resetFormAction, resetValidity: resetValidityFormAction, setErrors: setErrorsFormAction } = formActions;

export default connect(mapStateToProps, {
  createIssueAction,
  changeLocationAction,
  changeFormValueAction,
  resetFormAction,
  resetValidityFormAction,
  setErrorsFormAction,
}, undefined, { forwardRef: true })(IssueNewModal);
